<template>
  <div ref="wrapper">
    <slot></slot>
  </div>
</template>
<script type="text/ecmascript-6">
import BScroll from 'better-scroll'
export default {
  props: {
    probeType: {
      type: Number,
      default: 1
    },
    click: {
      type: Boolean,
      default: true
    },
    data: {
      type: Array,
      default: null
    },
    pullup: {
      type: Boolean,
      default: false
    },
    loaded: {
      type: Boolean,
      default: false
    },
    // 是否浏览器默认事件
    preventDefault: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    setTimeout(() => {
      this._initScroll()
    }, 20)
  },
  created() {
  },
  methods: {
    _initScroll() {
      if (!this.$refs.wrapper) {
        return
      }
      this.scroll = new BScroll(this.$refs.wrapper, {
        probeType: this.probeType,
        click: this.click,
        preventDefault: this.preventDefault
      })
      this.scroll.on('scrollStart', () => {
        // 修复scroll 下input不能失去焦点
        let ele
        if ((ele = document.querySelector('.search-input-ele'))) {
          ele.blur()
        }
        if (this.scroll.y <= (this.scroll.maxScrollY)) {
          // 如果滚动到底部, 刷新组件
          // this.scroll.refresh()
          // 是否派发滚动到底部事件，用于上拉加载
          if (this.pullup) {
            this.$emit('scrollToEnd')
          }
        }
      })
    },
    disable() {
      this.scroll && this.scroll.disable()
    },
    enable() {
      this.scroll && this.scroll.enable()
    },
    refresh() {
      this.scroll && this.scroll.refresh()
    }
  },
  watch: {
    data() {
      setTimeout(() => {
        this.refresh()
      }, 20)
    },
    loaded() {
      setTimeout(() => {
        this.refresh()
      }, 100)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/base/scroll/scroll.vue